import { render } from "./questionComponent.vue?vue&type=template&id=535d4671&scoped=true"
import script from "./questionComponent.vue?vue&type=script&lang=js"
export * from "./questionComponent.vue?vue&type=script&lang=js"

import "./questionComponent.vue?vue&type=style&index=0&id=535d4671&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535d4671"],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/questionComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "535d4671"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('535d4671', __exports__)) {
    api.reload('535d4671', __exports__)
  }
  
  module.hot.accept("./questionComponent.vue?vue&type=template&id=535d4671&scoped=true", () => {
    api.rerender('535d4671', render)
  })

}


export default __exports__